import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileCatOpen, setMobileCatOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md shadow-sm">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-[4.5rem]">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2 group flex-shrink-0">
              <span className="font-heading text-xl md:text-2xl font-bold text-foreground-900 tracking-tight">
                USFans<span className="text-accent-500">.</span>
              </span>
            </Link>
            <div className="hidden md:flex items-center gap-5">
              <Link to="/" className="text-sm font-semibold text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap">
                Strona główna
              </Link>
              <Link to="/artykul/usfans-spreadsheet-kompletny-przewodnik" className="text-sm font-semibold text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap">
                Artykuły
              </Link>
              <Link to="/artykul/usfans-spreadsheet-jak-zaczac" className="text-sm font-semibold text-foreground-700 hover:text-foreground-900 transition-colors whitespace-nowrap">
                Poradnik zakupów
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-2 md:gap-3">
            <div className="relative hidden md:block" ref={dropdownRef}>
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-4 py-2 text-sm font-semibold text-foreground-700 bg-background-100 hover:bg-background-200 rounded-lg transition-colors whitespace-nowrap border border-background-200"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-grid-line text-sm"></i>
                </span>
                Kategorie
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className={dropdownOpen ? 'ri-arrow-up-s-line text-xs' : 'ri-arrow-down-s-line text-xs'}></i>
                </span>
              </button>
              {dropdownOpen && (
                <div className="absolute top-full right-0 mt-2 w-64 bg-background-50 rounded-xl shadow-lg border border-background-200 overflow-hidden z-50 max-h-80 overflow-y-auto">
                  {categories.map((cat) => (
                    <a
                      key={cat.slug}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="block px-4 py-2.5 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-900 transition-colors whitespace-nowrap"
                      onClick={() => setDropdownOpen(false)}
                    >
                      {cat.name}
                    </a>
                  ))}
                </div>
              )}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="hidden sm:inline-flex items-center px-4 py-2 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap"
            >
              USFans Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center px-4 py-2 text-sm font-semibold text-accent-600 border-2 border-accent-300 hover:bg-accent-50 rounded-lg transition-colors whitespace-nowrap"
            >
              Kup teraz
            </a>

            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden flex items-center justify-center w-10 h-10 rounded-lg text-foreground-700 hover:bg-background-100 transition-colors"
              aria-label="Menu"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className={mobileOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
              </span>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 shadow-lg">
          <div className="px-4 py-4 space-y-3 max-h-[80vh] overflow-y-auto">
            <Link
              to="/"
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold text-foreground-700 hover:bg-background-100 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-home-4-line"></i>
              </span>
              Strona główna
            </Link>
            <Link
              to="/artykul/usfans-spreadsheet-kompletny-przewodnik"
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold text-foreground-700 hover:bg-background-100 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-article-line"></i>
              </span>
              Artykuły
            </Link>
            <Link
              to="/artykul/usfans-spreadsheet-jak-zaczac"
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-semibold text-foreground-700 hover:bg-background-100 transition-colors"
              onClick={() => setMobileOpen(false)}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-bag-3-line"></i>
              </span>
              Poradnik zakupów
            </Link>

            <button
              onClick={() => setMobileCatOpen(!mobileCatOpen)}
              className="flex items-center justify-between w-full px-3 py-2.5 rounded-lg text-sm font-semibold text-foreground-700 hover:bg-background-100 transition-colors"
            >
              <span className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-grid-line"></i>
                </span>
                Kategorie
              </span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={mobileCatOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}></i>
              </span>
            </button>
            {mobileCatOpen && (
              <div className="pl-10 space-y-1 pb-2">
                {categories.map((cat) => (
                  <a
                    key={cat.slug}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="block px-3 py-2 text-sm text-foreground-600 hover:text-foreground-900 hover:bg-background-100 rounded-lg transition-colors whitespace-nowrap"
                    onClick={() => { setMobileOpen(false); setMobileCatOpen(false); }}
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            )}

            <div className="pt-2 border-t border-background-200 flex flex-col gap-2">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-4 py-3 text-sm font-semibold text-accent-600 border-2 border-accent-300 hover:bg-accent-50 rounded-lg transition-colors whitespace-nowrap"
                onClick={() => setMobileOpen(false)}
              >
                Kup teraz
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center justify-center gap-2 w-full px-4 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap"
                onClick={() => setMobileOpen(false)}
              >
                USFans Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}